<template>
  <footer class="ew-footer ew-footer--primary mt-0">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6 col-md-3 align-self-center text-center">
          <img src="@/assets/images/logo-enviosweb-blanco.png" height="75" alt="">
        </div>
        <div class="col-md-9 ew-border-left">
          <div class="row mb-2">
            <div class="col-sm-6 col-md-4">
              <div class="row mb-2">
                <div class="col">
                  <ul>
                    <li><h4>CONTACTO</h4></li>
                    <li><router-link to="/politicas-de-privacidad"> Políticas</router-link></li>
                    <li><router-link to="/terminos-de-servicio"> Términos y Condiciones</router-link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-4">
              <ul>
                <li><h4>SOPORTE</h4></li>
                <li><a href="#">Ayuda con logística</a></li>
                <li><router-link to="/contactanos">Ayuda general</router-link></li>
                <li><router-link to="/preguntas-frecuentes"> Preguntas frecuentes</router-link></li>
              </ul>
            </div>
            <div class="col-sm-6 col-md-4">
              <h4>SÍGUENOS EN REDES SOCIALES</h4>
              <a href="https://www.facebook.com/enviosweb.mx/" class="ew-icon pl1" target="_blank">
                <img src="@/assets/images/Facebook.svg" alt="">
              </a>
              <a href="https://www.instagram.com/enviosweb/" class="ew-icon" target="_blank">
                <img src="@/assets/images/Instagram.svg" alt="">
              </a>
              <a href="https://www.youtube.com/channel/UCLwSwMd-czMjC60ajlv-zzQ" class="ew-icon" target="_blank">
                <img src="@/assets/images/youtube-.svg" alt="">
              </a>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <ul>
                <li>
                  <h4><span class="mr-2">METODOS DE PAGO:</span> <img src="@/assets/images/Paypal-Logo-white.png" alt="" class="mr-2"> <img src="@/assets/images/oxxo.png" alt=""></h4>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterPublic'
}
</script>



// WEBPACK FOOTER //
// src/components/Header/FooterPublic.vue